import CustomButton from './customButton';

export default CustomButton;